import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f3d1800"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "no-goods flex-center" }
const _hoisted_2 = {
  key: 0,
  class: "no-goods-empty"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/empty.png",
  alt: "",
  class: "empty"
}, null, -1))
const _hoisted_4 = { class: "text" }
const _hoisted_5 = {
  key: 1,
  class: "no-goods-empty"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/no_goods.png",
  alt: "",
  class: "empty",
  style: {"width":"130px"}
}, null, -1))
const _hoisted_7 = { class: "text" }
const _hoisted_8 = {
  key: 2,
  class: "no-goods-empty"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/no_goods.png",
  alt: "",
  class: "empty",
  style: {"width":"130px"}
}, null, -1))
const _hoisted_10 = {
  key: 3,
  class: "no-goods-empty"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/no_goods.png",
  alt: "",
  class: "empty",
  style: {"width":"130px"}
}, null, -1))
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 4,
  class: "no-goods-empty"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/no_goods.png",
  alt: "",
  class: "empty",
  style: {"width":"130px"}
}, null, -1))
const _hoisted_15 = { class: "text" }

import { t } from '@/plugins/i18n'
import { ref, computed } from 'vue'
import { isJA, isJpPurchase, isShopifyShop } from '@/store'
import { ShopType } from '@/common/const'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  props: ['type', 'shopDetail'],
  emits: ['change', 'addGoods'],
  setup(__props, { emit: emits }) {

const props = __props


const store = useStore()
// 三方关联 是否显示 tiktok 库存
const isTiktok = computed(() => store.getters?.shopInfo?.customerShopPlatform === ShopType.TIKTOK)
// unauthorized  未授权展示
// authorizationSelection  已授权去选择
// noGoods 商品为空时
// noSyncGoods 没有同步商品时
// chooseProduct 选择供货商品

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.type === 'unauthorized')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('当前店铺未授权同步数据功能，授权后可绑定商品，享受自动下单功能')), 1),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('change')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('去授权')), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (__props.type === 'authorizationSelection')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('当前店铺已授权同步数据功能，去选择要绑定的商品')), 1),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('change')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('去选择2')), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (__props.type === 'noSyncGoods')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", {
            class: "text",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('change')))
          }, _toDisplayString(_unref(t)('请点击“同步商品”')), 1)
        ]))
      : _createCommentVNode("", true),
    (__props.type === 'chooseProduct')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", {
            class: "text",
            style: {"padding":"0 15%"},
            innerHTML: _unref(isTiktok) ? _unref(t)('可支持绑定多个商品，前往去绑定库存商品1') : _unref(t)('可支持绑定多个商品，前往去绑定库存商品')
          }, null, 8, _hoisted_12),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "btn",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (emits('change')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('去选择3')), 1)
            ]),
            _: 1
          }),
          (_unref(isJpPurchase)() && __props.shopDetail?.hasAddProduct !== 1 && _unref(isShopifyShop)())
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "btn",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (emits('addGoods')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('新增商品')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (__props.type === 'noGoods')
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('暂无商品，请先去搜索商品')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})